import { createApi } from '@reduxjs/toolkit/query/react';
import { FUNDS_LIST_API } from 'services/constants';
import { rawBaseQuery } from 'services/shared';
import {
  FundDetailsApi,
  FundDetailsApiOptions,
  FundsListResponse,
} from 'services/types';

export const fundsApi = createApi({
  reducerPath: FUNDS_LIST_API,
  baseQuery: rawBaseQuery,
  endpoints: (builder) => ({
    getFundsList: builder.query<FundsListResponse[], string>({
      query: (valuationDate) =>
        encodeURI(`/funds?valuationDate=${valuationDate}`),
    }),
    getFundDetails: builder.query<FundDetailsApi[], FundDetailsApiOptions>({
      query: ({ valuationDate, measureType }) =>
        encodeURI(
          `/funds/measures?valuationDate=${valuationDate}&measureType${measureType}`
        ),
    }),
  }),
});

export const { useGetFundsListQuery, useGetFundDetailsQuery } = fundsApi;
